<app-bookupp-header></app-bookupp-header>

<div class="jumbotron jumbotron-fluid">
    <div class="container-fluid flex-item mx-3 mx-md-5">
        <div class="row">
            <div class="col-12 col-md-6 p-5 d-flex align-items-center">
                <div>
                    <h1 class="hero-header text-light extra-large py-4">A better way to manage workplace parking</h1>
                    <p class="text-white">
                        ReserveUpp is South Africa’s automated parking reservation system for businesses. The goal? To make workplace parking simple and fair. Revolutionise your parking experience
                        with
                        us!
                    </p>
                    <br />
                    <div class="call-to-action">
                        <a class="btn btn-primary" href="/bookupp#contact-form-anchor">Book a Demo Session</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 d-none d-sm-block text-center d-flex align-items-center p-5">
                <img src="/assets/images/bookupp/phone.png" />
            </div>
        </div>
    </div>
</div>

<div class="container-fluid py-md-5">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-4 mt-4 mt-lg-0 py-5 px-5 text-center">
                <img src="/assets/images/pages/bookupp/icons/allocate.png" />
                <h4 class="text-primary mb-3 mt-4">Book and allocate<br />parking bays</h4>
            </div>

            <div class="col-12 col-lg-4 mt-4 mt-lg-0 py-5 px-5 text-center">
                <img src="/assets/images/pages/bookupp/icons/reduce.png" />
                <h4 class="text-primary mb-3 mt-4">Reduce<br />parking-related<br />admin</h4>
            </div>

            <div class="col-12 col-lg-4 mt-4 mt-lg-0 py-5 px-5 text-center">
                <img src="/assets/images/pages/bookupp/icons/availability.png" />
                <h4 class="text-primary mb-3 mt-4">Maximise parking<br />availability</h4>
            </div>
        </div>
    </div>
</div>

<div class="listing-options container-fluid py-md-5 bg-dark-blue">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="mb-4 header-part-bold text-white">The benefits are endless</h1>
            </div>
        </div>
        <div class="row pb-4">
            <div class="col-12 col-lg-4 d-flex flex-column">
                <div class="block">
                    <div class="">
                        <img src="assets/images/pages/bookupp/image-1.png" />
                    </div>

                    <div class="p-4">
                        <h4 class="mb-4"><span class="header-part-bold">Empower Your Employees</span>&nbsp;</h4>
                        <div class=""><b>60% of employees</b> report feeling more satisfied when <b>parking is efficiently managed.</b></div>
                        <br />
                        <div class="">
                            ReserveUpp is a platform that <b>allows your employees to book a parking bay up to 7 days in advance</b> – providing parking certainty, minimising parking related stress
                            and
                            maximising employee satisfaction.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4 d-flex flex-column">
                <div class="block">
                    <div class="">
                        <img src="assets/images/pages/bookupp/image-2.png" />
                    </div>
                    <div class="p-4">
                        <h4 class="mb-4"><span class="header-part-bold">Less Hassle, More Productivity</span>&nbsp;</h4>
                        <div class="">
                            When you <b>automate the parking system</b>, office managers no longer need to co-ordinate parking, deal with parking- related queries or schedule bays for employees.
                        </div>
                        <br />
                        <div class="">This <b>frees up more time</b> for them to focus on their core business.</div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4 p-2 d-flex flex-column">
                <div class="block">
                    <div class="">
                        <img src="assets/images/pages/bookupp/image-3.png" />
                    </div>

                    <div class="p-4">
                        <h4 class="mb-4"><span class="header-part-bold">Get More Out Of Your Parking</span>&nbsp;</h4>
                        <div class="">By monitoring your parking more closely, you’re able to <b>boost parking capacity</b> and maximise the bays that you’re paying for!</div>
                        <br />
                        <div class=""><b>Reallocate dedicated bays</b> when employees are out of office and <b>distribute empty spaces to those who need them.</b></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="landlord-process py-md-5 bg-grey">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="">
                    <span class="header-part-bold">The perfect fit</span><br />
                    <span class="header-part-light"> for your company </span>
                </h1>
            </div>
            <p style="font-size: 24px; text-align: center; color: black">Here’s how it works:</p>
        </div>
        <div class="row">
            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <div class="block p-4">
                    <div class="mb-4">
                        <img src="/assets/images/pages/bookupp/icons/parking.png" />
                    </div>

                    <div class="after-marker">
                        <div class="">You create a parking lot diagram and upload it onto the system</div>
                    </div>

                    <div class="circle-arrow">
                        <i class="fas fa-angle-right"></i>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <div class="block p-4">
                    <div class="mb-4">
                        <img src="/assets/images/pages/bookupp/icons/allocate.png" />
                    </div>

                    <div class="after-marker">
                        <div class="">Your office manager assigns any dedicated bays</div>
                    </div>

                    <div class="arrow-outer mt-3">
                        <div class="circle-arrow">
                            <i class="fas fa-angle-right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <div class="block p-4">
                    <div class="mb-4">
                        <img src="/assets/images/pages/bookupp/icons/employee.png" />
                    </div>

                    <div class="after-marker">
                        <div class="">Employees get access to book their bays up to 7 days in advance</div>
                    </div>

                    <div class="arrow-outer mt-3">
                        <div class="circle-arrow">
                            <i class="fas fa-angle-right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <div class="block p-4">
                    <div class="mb-4">
                        <img src="/assets/images/pages/bookupp/icons/email.png" />
                    </div>

                    <div class="after-marker">
                        <div class="">An email confirmation is sent to the office manager at the end of each day</div>
                    </div>

                    <div class="arrow-outer mt-3">
                        <div class="circle-arrow">
                            <i class="fas fa-angle-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 py-5 text-center">
                <p style="font-size: 24px; text-align: center; color: black; font-style: italic">It’s that easy</p>
            </div>
        </div>
    </div>
</div>

<div class="pricing-overview py-md-5">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="">
                    <span class="header-part-light">Get</span>&nbsp;<span class="header-part-bold">ReserveUpp</span>&nbsp;<span class="header-part-light">for as little as</span><br />
                    <span class="header-part-bold">R10 per parker per month</span>
                </h1>
            </div>
            <div style="font-size: 24px; text-align: center; color: black">
                <div class="bullet-block">
                    <span class="circle-arrow">
                        <i class="fas fa-check"></i> </span
                    >Unlimited Parking Bays
                </div>

                <div class="bullet-block">
                    <span class="circle-arrow">
                        <i class="fas fa-check"></i> </span
                    >Unlimited Users
                </div>

                <div class="bullet-block">
                    <span class="circle-arrow">
                        <i class="fas fa-check"></i> </span
                    >24/7 Technical Support
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 py-5 text-center">
                <button class="btn btn-primary" href="/bookupp#contact-form-anchor">Book a Demo Session</button>
            </div>
        </div>
    </div>
</div>

<section class="contact-form my-5 bg-dark-blue">
    <a class="anchor-offset" id="contact-form-anchor"></a>
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-12 col-md-6 py-5 my-5">
                <h1 class="">
                    <span class="text-white">Interested</span>
                </h1>
                <p class="text-white my-4">Let us run you through the platform, show you how it works and share our expertise. All in 20 minutes. You are under no obligation to sign up!</p>

                <ng-container *ngIf="formComplete">
                    <div class="alert alert-success" role="alert">We have received your enquiry. We will contact you soon.</div>
                    <a [routerLink]="'/bookupp'" class="text-white text-decoration-underline">Click here to send another enquiry</a>
                </ng-container>
                <ng-container *ngIf="!formComplete">
                    <form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
                        <input class="form-control d-none" formControlName="type" type="text" />

                        <div class="row">
                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label text-white">Name</label>
                                <input class="form-control" formControlName="name" type="text" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label text-white">Email Address</label>
                                <input class="form-control" formControlName="email" type="email" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label text-white">Phone</label>
                                <input class="form-control" formControlName="phone" type="text" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label text-white">Company</label>
                                <input class="form-control" formControlName="company" type="text" />
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label text-white">Building Address</label>
                            <input class="form-control" formControlName="location" type="text" />
                        </div>

                        <ng-container *ngIf="formError">
                            <div class="alert alert-danger pa-3" role="alert">
                                <pre>{{ formError }}</pre>
                            </div>
                        </ng-container>

                        <ng-container [ngTemplateOutlet]="formLoading ? formInvalidTemplate : validTemplate"></ng-container>
                        <ng-template #formSubmittingTemplate>
                            <button class="btn btn-primary" disabled type="submit">
                                <span aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span>
                                Loading...
                            </button>
                        </ng-template>
                        <ng-template #formInvalidTemplate>
                            <button class="btn btn-primary" disabled type="submit">Submit</button>
                        </ng-template>
                        <ng-template #validTemplate>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </ng-template>
                    </form>
                </ng-container>
            </div>
        </div>
    </div>
</section>

<app-bookupp-footer></app-bookupp-footer>
